import DatePicker from "react-datepicker";
import { Dispatch, SetStateAction, useRef, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import '../../css/datePicker.css';
import { ko } from "date-fns/locale";
import { getMonth, getYear } from "date-fns";
import { MdOutlineArrowBackIosNew } from 'react-icons/md'
import { MdOutlineArrowForwardIos } from 'react-icons/md'

interface IProps {
  date: Date;
  setDate: Dispatch<SetStateAction<Date>>;
  setDateView: Dispatch<SetStateAction<string>>;
  setDatePopup: Dispatch<SetStateAction<boolean>>;
  prodRef: any;
}

const CustomDatePicker = (props: IProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const _ = require("lodash");
  const years = _.range(1943, getYear(new Date()) + 5, 1); // 연도 선택 select box에 보여질 데이터 : range(시작 연도, 끝 연도, 연도 간격)
  const months = [  // 월 선택 select box에 보여질 데이터
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const onChange = (date: any) => {
    props.setDate(date);
    props.setDatePopup(false);
  };
  useEffect(() => {
    // 이벤트 핸들러 함수
    const handler = (e: any) => {
      // mousedown 이벤트가 발생한 영역이 모달창이 아닐 때, 모달창 제거 처리
      if (modalRef.current && !modalRef.current.contains(e.target) && !props.prodRef.current.contains(e.target)) {
        props.setDatePopup(false);
      }
    };
    // 이벤트 핸들러 등록
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler); // 모바일 대응
    return () => {
      // 이벤트 핸들러 해제
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler); // 모바일 대응
    };
  });

  return (
    <div ref={modalRef}>
      <DatePicker
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="custom-react-datepicker__select-wrapper">
            {/* 이전 월로 이동하는 버튼 */}
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              <MdOutlineArrowBackIosNew />
            </button>
            <div className="custom-react-datepicker__select-item md:after:w-[18px] md:after:h-[18px] md:after:border-white md:after:border-b-3 md:after:border-r-3 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[255px] md:after:mb-[12px]">
              {/* 연도 선택 select box */}
              <select
                value={getYear(date)}
                onChange={({ target: { value } }) => changeYear(Number(value))}
                className="md:appearance-none"
              >
                {years.map((option: any) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <span>년</span>
            </div>
            <div className="custom-react-datepicker__select-item md:after:w-[18px] md:after:h-[18px] md:after:border-white md:after:border-b-3 md:after:border-r-3 md:after:transform md:after:rotate-45 md:after:absolute md:after:left-[495px] md:after:mb-[12px]">
              {/* 월 선택 select box */}
              <select
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
                className="md:appearance-none"
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <span>월</span>
            </div>
            {/* 다음 월로 이동하는 버튼 */}
            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              <MdOutlineArrowForwardIos />
            </button>
          </div>
        )}
        locale={ko} // (월~일 부분) 한국어로 변환
        inline
        selected={props.date}
        onChange={(date) => onChange(date)} // 선택한 날짜를 state에 저장
      />
    </div>
  );
};

export default CustomDatePicker;